'use client'

import {useEffect} from 'react'
import {getInjection} from '@runlab/di'
import {ProductDetailEvents} from '@/src/core/domain/events/product.events'
import {useStore} from '@/src/shared/hooks/useStore'
import {CatalogProductContent} from '@/src/core/domain/entities/catalog'
import {observer} from 'mobx-react'
import {observable} from 'mobx'
import first from 'lodash/first'

const productAnalythicPushed = observable({
  pushed: false,
  setPushed(pushed: boolean) {
    this.pushed = pushed
  },
})

export const ProductAnalyticProvider = observer(({children}: React.PropsWithChildren) => {
  const {pageData} = useStore<CatalogProductContent>()

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (pageData && !productAnalythicPushed.pushed) {
        productAnalythicPushed.setPushed(true)
        getInjection('IEventBus').publish(
          ProductDetailEvents.productView({
            id:
              (pageData.content.product.type === 'with_variants' &&
                first(pageData.content.product.variants)?.id) ||
              pageData.content.product.id,
          }),
        )
      }
    }, 500)

    return () => {
      productAnalythicPushed.setPushed(false)
      clearTimeout(timeoutId)
    }
  }, [pageData])

  return children
})
